import React from "react";
import DateChangeButtons from "./DateChangeButtons";
import { DatePickerToolbarProps } from "@mui/x-date-pickers";
import { Box } from "@mui/material";

export default function DateChangeButtonsToolbar(props: DatePickerToolbarProps) {
  return (
    <Box className={props.className}>
      <DateChangeButtons />
    </Box>
  );
}
